import { isPlatformBrowser } from '@angular/common';
import {AfterViewInit, Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, signal, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {CommunityDTO} from "../../../DTO/CommunityDTO";
import {InscriptionsDTO} from "../../../DTO/InscriptionsDTO";
import { environment } from 'src/environments/environment';
import {ImageUrlPipe} from "../../../pipes/image-url.pipe";
import {ApiService} from "../../../services/api.service";
import {CommunityService} from "../../../services/community/community.service";
import {Title} from "@angular/platform-browser";
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {InscriptionFormComponent} from "../inscription-form/inscription-form.component";
import {CustomFieldValueDTO} from "../../../DTO/CustomFieldValueDTO";
import {DateTime} from "luxon";
import Swal from "sweetalert2";
import {TranslateService} from "@ngx-translate/core";
import { InscriptionsConstants } from '../constants';
import { ScreenSizeService } from 'src/app/services/screen-size.service';
import { MetadataService } from 'src/app/services/metadata.service';
import { Functions } from 'src/app/helpers/Functions';
import {Subscription} from "rxjs";
import {InscriptionsService} from "../inscriptions.service";
import {WaitingListComponent} from "../waiting-list/waiting-list.component";
import {WaitingListCodeMinDTO} from "../../../DTO/WaitingListCodeMinDTO";
import {WaitingListInfoDTO} from "../../../DTO/WaitingListInfoDTO";
@Component({
  selector: 'app-inscriptions-detail',
  templateUrl: './inscriptions-detail.component.html',
  styleUrl: './inscriptions-detail.component.scss'
})
export class InscriptionsDetailComponent implements OnInit , AfterViewInit {

  public OpenStatuses = InscriptionsConstants.OpenStatuses;
  public readonly showAttendedButton = signal(false);
  @ViewChild("sectionSubscribe", { static: true }) sectionSubscribeDiv: ElementRef;
  private ref: DynamicDialogRef | undefined;
  inscriptionId: string;
  inscription?: InscriptionsDTO;
  community?: CommunityDTO;
  public freePlaces: number;
  public accessCode: string = null;
  public waitingListUserDetails: WaitingListInfoDTO;
  public openStatus: string;
  public isFull: boolean = false;
  public openCancelModal: boolean = false;
  public allowWaitingList : boolean = false;
  public colorCorp: string;
  customFieldValues: CustomFieldValueDTO[];
  communityName: string = "";
  public defaultImg: string;
  public isLoading = true;
  public dateFrom: Date;
  public dateTo: Date;
  public isMobile: boolean;
  public dateOpen: DateTime;
  public dateClose: DateTime;
  private availabilitySubscription!: Subscription;
  @HostListener('window:resize') onresize() {
    this.isMobile = this.screenSizeService.isScreenSmall();
  }
  faArrowLeft = faArrowLeft;
  constructor(
    private actRoute: ActivatedRoute,
    private route: Router,
    private apiService: ApiService,
    private communityService: CommunityService,
    private titleService: Title,
    private dialogService: DialogService,
    private translate: TranslateService,
    private screenSizeService: ScreenSizeService,
    private metadataService: MetadataService,
    private srv: InscriptionsService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    this.inscriptionId = this.actRoute.snapshot.params['id'];
    this.communityName = this.actRoute.snapshot.params['community'];
    this.accessCode = this.actRoute.snapshot.queryParamMap.get('AccessCode');
    if (this.accessCode && this.inscriptionId) {

      var objectAccesCode = new WaitingListCodeMinDTO();
      objectAccesCode.inscriptionId = Number(this.inscriptionId);
      objectAccesCode.accessCode = this.accessCode;

      this.apiService
          .checkAccesCode(this.communityName, objectAccesCode)
          .subscribe({
            next: (x) => {
                  this.waitingListUserDetails = x;
                  this.waitingListUserDetails.accesCode = this.accessCode;
                  var cancel = this.actRoute.snapshot.queryParamMap.get('cancel');
                  if(cancel){
                    this.confirmRejectWaitingList();
                  }

            },
            error: (err) => {
              this.handleWaitingListError(err);
            }
          });
    }
  }

  ngOnInit(): void {
    this.isMobile = this.screenSizeService.isScreenSmall();
    this.defaultImg = this.communityService.defaultImg;
    this.communityService.Get().subscribe(x=>{
      this.colorCorp = x.color1;
    })
    this.init();

  }

  ngOnDestroy(){
    this.availabilitySubscription?.unsubscribe();
  }

  scrollToSubscribe(){
    this.sectionSubscribeDiv.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.scrollToSubscribe()
    }, 0);
  }

  getCommunity() {
    this.apiService.getCommunityByCode(this.communityName).subscribe(responseData => {
      this.community = responseData;
    })
  }
  
  private requiresAppRedirect(inscription: InscriptionsDTO): boolean {
    const hasValidationRule = inscription.validationRule != null && inscription.validationRule !== 'None';
    return hasValidationRule
      || inscription.minimumAge != null
      || inscription.maximumAge != null;
  }

  private buildAppInscriptionUrl(inscriptionId: number): string {
    const appHost = environment.production ? 'app.wetown.app' : `app.${environment.tag}.wetown.app`;
    const params = new URLSearchParams({ web: '1' });
    if (this.accessCode) {
      params.set('AccessCode', this.accessCode);
    }
    return `https://${appHost}/c/${this.communityName}/inscriptions/${inscriptionId}?${params}`;
  }

  private redirectToAppInscriptionIfNeeded(inscription: InscriptionsDTO): boolean {
    if (!this.requiresAppRedirect(inscription) || !isPlatformBrowser(this.platformId)) {
      return false;
    }

    window.location.href = this.buildAppInscriptionUrl(inscription.id);
    return true;
  }

  private init() {

    this.getCommunity();
    this.apiService.getOneInscription(this.communityName, Number(this.inscriptionId))
      .subscribe(responseData => {
        if (responseData) {
          if (this.redirectToAppInscriptionIfNeeded(responseData)) {
            return;
          }

          this.inscription = responseData;
          this.getFieldsAdditionalInfo();
          this.showAttendedButton.set(
            this.inscription.isAttended
            && !InscriptionsConstants.HideAttendedButtonInscriptionIds.includes(this.inscription.id)
          );

          if(this.inscription.images && this.inscription.images.length > 0) {
            const absoluteImageUrl = new ImageUrlPipe().transform(this.inscription?.images[0].path);

            const metadataObj = {
              title: Functions.decode(this.inscription?.name),
              description: Functions.decode(this.inscription.name),
              image: absoluteImageUrl ? Functions.decode(absoluteImageUrl) : null
            };

            this.metadataService.updateMetadata(metadataObj);
          }

          this.titleService.setTitle(this.inscription?.name);

          this.dateOpen = DateTime.fromISO(this.inscription.dateOpen);
          this.dateClose = DateTime.fromISO(this.inscription.dateClose);

          if (this.dateOpen <= DateTime.now() && this.dateClose > DateTime.now()){
            this.openStatus = InscriptionsConstants.OpenStatuses.OPEN;
          } else if (this.dateOpen > DateTime.now()){
            this.openStatus = InscriptionsConstants.OpenStatuses.FUTURE;
          } else if (this.dateClose < DateTime.now()){
            this.openStatus = InscriptionsConstants.OpenStatuses.PAST;
          }

          if (this.openStatus == InscriptionsConstants.OpenStatuses.OPEN){
            this.availabilitySubscription = this.srv.subscribeToAvailability(parseInt(this.inscriptionId))
                .subscribe((res : any) =>{
                  this.freePlaces = res.freePlaces;

                  this.isFull = (this.freePlaces != null && this.freePlaces <= 0);

                });
          }
          const hasGroups = (this.inscription.groups?.length ?? 0) > 0;


          this.isLoading = false;
        }
      });
  }
  public getFieldsAdditionalInfo(){
    this.apiService.getCustomFieldsValues(this.communityName, Number(this.inscriptionId))
      .subscribe(responseData => {
        this.customFieldValues = responseData.filter(x=> x.customFieldPublicPermissions == "r");
      });
  }
  public confirmRejectWaitingList() {
    Swal.fire({
      icon: 'info',
      title: this.translate.instant('WAITING_LIST.CONFIRM_EXIT_TITLE'),
      text: this.translate.instant('WAITING_LIST.CONFIRM_EXIT_MESSAGE'),
      showCancelButton: true,
      confirmButtonText: this.translate.instant('WAITING_LIST.CANCEL'),
      cancelButtonText: this.translate.instant('WAITING_LIST.CONFIRM'),
      customClass: {
        confirmButton: 'swal-confirm-corp'
      },
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.rejectWaitingList();
      }
    });
  }

  public rejectWaitingList() {
    this.apiService
        .rejectWaitingLsit(this.communityName, this.waitingListUserDetails.id)
        .subscribe(() => {
          Swal.fire({
            icon: 'info',
            title: this.translate.instant('WAITING_LIST.CANCELLED_TITLE'),
            text: this.translate.instant('WAITING_LIST.CANCELLED_MESSAGE'),
            confirmButtonText: this.translate.instant('Accept'),
            customClass: {
              confirmButton: 'swal-confirm-corp'
            },
          });
         this.cleanAccesCodeWaitingList();

        });
  }

  public cleanAccesCodeWaitingList(){
    this.route.navigate([], {
      relativeTo: this.actRoute,
      queryParams: { AccessCode: null },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
    this.waitingListUserDetails = null;
    this.accessCode = null;
  }


  public openInscriptionForm() {
    this.ref = this.dialogService.open(InscriptionFormComponent,
      {
        closable: true,
        position: 'top',
        data: { inscription : this.inscription ,
        route:this.actRoute,
        waitingListInfo : this.waitingListUserDetails},
        styleClass: "top-position-class form-modal",
        width: '1000px',
        header: this.inscription?.name,
        appendTo: 'body'
      })
      this.ref.onClose.subscribe(result => {
        if (!result) {
          return;
        }
        if (result.action === 'buyed') {
          this.cleanAccesCodeWaitingList();
        }
        if (result.action === 'OPEN_WAITING_LIST') {
         this.openWaitingListForm(result.group);
        }
      });
  }


  public openWaitingListForm(groupId?: number) {

    this.ref = this.dialogService.open(WaitingListComponent, {
          closable: true,
          position: 'top',
          data: { inscription : this.inscription , groupId: groupId , communityName: this.communityName },
          header:  this.translate.instant('INSCRIPTIONS.WaitingList.Title') + ": " + this.inscription?.name,
          styleClass: "top-position-class form-modal waiting-list-modal",
          width: '1000px',
          appendTo:'body'
        })
  }

  public getBasePriceDisplayMode(): 'hidden' | 'free' | 'amount' | 'from' {
    if (!this.inscription) {
      return 'hidden';
    }
    const paid = (this.inscription.basePrice ?? 0) > 0;
    if (!paid) {
      return this.inscription.priceVisibility === 'Hide' ? 'hidden' : 'free';
    }
    return this.inscription.priceVisibility === 'ShowFrom' ? 'from' : 'amount';
  }

  private handleWaitingListError(err: any): void {
    const code = err?.error?.code;

    let titleKey = '';
    let textKey = '';

    switch (code) {
      case 'EXPIRED_ACCESS':
        titleKey = 'WAITINGLIST.ExpiredTitle';
        textKey = 'WAITINGLIST.ExpiredSubtitle';
        break;

      case 'INVALID_ACCESS':
        titleKey = 'WAITINGLIST.InvalidTitle';
        textKey = 'WAITINGLIST.InvalidSubtitle';
        break;

      default:
        titleKey = 'WAITINGLIST.GenericErrorTitle';
        textKey = 'WAITINGLIST.GenericErrorSubtitle';
        break;
    }

    Swal.fire({
      title: this.translate.instant(titleKey),
      text: this.translate.instant(textKey),
      icon: 'error',
      confirmButtonText: this.translate.instant('Accept'),
      customClass: {
        confirmButton: 'swal-confirm-corp'
      },
    }); 
  } 
}
